import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PricingActions } from 'state/modules/pricing';
import { Box, Button, Grid, Paper, Container, Typography } from '@material-ui/core';
import { buildUrl } from 'utils';
import i18n from 'i18n-js';
import Can from 'components/Can';
import Logs from 'components/Logs';
import Title from 'components/Title';
import Layout from 'components/Layout';
import Comments from 'components/Comments';
import { useParams } from 'react-router-dom';
import useStyles from './TaxRulesetDetails.styled';
import { TaxRulesetTable, SKUsAssociated, TaxRulesetHistory } from 'components/TaxRuleset';
import { useHistory } from 'react-router-dom';
import { AuthActions } from 'state/modules/auth';

const TaxRulesetDetails = () => {
  const classes = useStyles();
  const history = useHistory();

  const dispatch = useDispatch();
  const { id } = useParams();

  const { name, taxes, description, origin_id, archived } = useSelector(
    (state) => state.pricing?.currentTaxRuleset
  );

  const taxRulesetsEnabled = useSelector(
    (state) => state.config?.settings?.core?.pricing?.tax_rules_set?.enabled
  );

  useEffect(() => {
    if (!taxRulesetsEnabled) {
      dispatch(AuthActions.unauthorized());
    }
    if (id && taxRulesetsEnabled) {
      dispatch(PricingActions.fetchTaxRulesetById(id));
    }

    return () => {
      dispatch(PricingActions.resetCurrentTaxRuleset());
    };
  }, [id, taxRulesetsEnabled, dispatch]);

  return (
    <Layout title={i18n.t('ruleset.title')}>
      {taxRulesetsEnabled ? (
        <Container className={classes.container}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid
                container
                spacing={4}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  <Title title={name || ''} />
                </Grid>
                {!archived ? (
                  <Can I="update" a="tax_rules_set">
                    <Grid item>
                      <Button
                        onClick={() => {
                          history.push(buildUrl(`/tax-rulesets/${id}/update`));
                        }}
                        style={{ textTransform: 'capitalize' }}
                        variant="contained"
                        color="primary"
                        data-cy="update-tax-ruleset-btn"
                      >
                        {i18n.t('tax_ruleset.update')}
                      </Button>
                    </Grid>
                  </Can>
                ) : null}
              </Grid>
              <Grid item xs={12}>
                <Paper elevation={2} className={classes.paper}>
                  <Typography variant="h6" align="left">
                    <Box fontWeight="normal" fontSize={13}>
                      {description}
                    </Box>
                  </Typography>
                  <Grid container>
                    <Grid item xs={12} style={{ marginTop: 15 }}>
                      <TaxRulesetTable id={id} action="details" taxes={taxes || []} />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid container spacing={4} direction="row">
                <Grid item xs={12} sm={6} md={4}>
                  <SKUsAssociated id={parseInt(id)} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Grid container spacing={4}>
                    <Can I="read" a="comment">
                      <Grid item xs={12}>
                        <Comments type="tax_rule_set" id={parseInt(id)} />
                      </Grid>
                    </Can>
                    <Can I="read" on="event_log">
                      <Grid item xs={12}>
                        <Logs
                          targetId={parseInt(id)}
                          targetType="TaxRulesSet"
                          title={i18n.t('tax_ruleset.logs')}
                        />
                      </Grid>
                    </Can>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TaxRulesetHistory originId={origin_id} excludeTaxRuleset={parseInt(id)} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      ) : (
        <></>
      )}
    </Layout>
  );
};

export default TaxRulesetDetails;
